import {
  GOOGLE_ANALYTICS_4,
  INITIALIZE_LOCATION_PIXEL,
  SET_REFERRAL_SOURCE
} from 'bento-ordering/base/constants/tracking';

const initialState = {
  ga4Initialized: false,
  initializedPixels: [],
  referralSource: ''
};

const trackingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GOOGLE_ANALYTICS_4:
      return {
        ...state,
        ga4Initialized: true
      };
    case INITIALIZE_LOCATION_PIXEL:
      return {
        ...state,
        initializedPixels: [
          ...state.initializedPixels,
          action.payload.locationPixel
        ]
      };
    case SET_REFERRAL_SOURCE:
      return {
        ...state,
        referralSource: action.payload.referralSource
      };

    default:
      return { ...state };
  }
};

export default trackingReducer;
